import React, { useEffect, useState } from "react"
import { Loader, Modal, Table } from 'rsuite'
import LoaderComponent from "../CommonComponents/LoaderComponent"
import { useDispatch } from "react-redux"
import { checkContactLinkedWithMaster, deleteContact, updateContact } from "../../redux/actions/contact"
import { toast } from "../CommonComponents/ToastComponent/toast"
import CreateContact from "./createContact"
import ModalComponent from "../CommonComponents/Modal"
const { Column, HeaderCell, Cell, Pagination } = Table

export const ActionCell = ({ rowData, onActivateDeactivateClick, onEditClick, dataKey, isContactLinkedLoading = false, ...props }) => {
    const btnText = rowData?.status ? 'Deactivate' : 'Activate'
    const btnBg = rowData?.status ? 'bg-red' : 'bg-dark-blue'
    return (
        <Cell {...props} className="table-action" fixed>
            <div className="action-buttons d-flex gap-2">
                <button type="button" className={`width-100 rounded py-2 fs-5 mb-0 text-white ${btnBg}`} onClick={() => { !isContactLinkedLoading?.isLoading && onActivateDeactivateClick(rowData) }}>
                    {isContactLinkedLoading?.isLoading && isContactLinkedLoading?.contactId === rowData?.id ? (
                        <Loader size="sm" />
                    )
                        : btnText
                    }
                </button>
                <button type="button" className="width-100 bg-green rounded py-2 fs-5 mb-0 text-white" onClick={() => { onEditClick(rowData?.id) }}>Edit</button>
            </div>
        </Cell >
    )
}

const Contacts = ({ contactsData = [], onGetContactsData }) => {
    const dispatch = useDispatch()
    const columns = [
        {
            name: 'firstname',
            label: 'First Name'
        },
        {
            name: 'lastname',
            label: 'Last Name'
        },
        {
            name: 'email',
            label: 'Email'
        },
        {
            name: 'phone',
            label: 'Phone'
        },
        {
            name: 'title',
            label: 'Title'
        },
        {
            name: 'status',
            label: 'Status'
        },
        {
            name: 'pronunciation',
            label: 'Pronunciation'
        },
        {
            name: 'pronouns',
            label: 'Pronouns'
        }
    ]
    const [contacts, setContacts] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [contactId, setContactId] = useState(null)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isContactLinkedLoading, setIsContactLinkedLoading] = useState({
        isLoading: false,
        contactId: null
    })
    const [isRelaodContacts, setIsRelaodContacts] = useState(false)

    useEffect(() => {
        if (contactsData?.length > 0) {
            setContacts(contactsData)
        } else {
            setContacts([])
        }
    }, [contactsData])

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    const headerElements = columns.map((col) => {
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell title={col.label}>{col.label}</HeaderCell>
                <Cell dataKey={col.name}>
                    {rowData => {
                        if (col.name === 'status') {
                            var status = rowData?.[col.name] ? 'Active' : "In-Active"
                            return <p title={status ? status : ''} className="mb-0 text-black">{status ? status : ''}</p>
                        }
                        return <p title={rowData?.[col.name] ? rowData?.[col.name] : ''} className="mb-0 text-black">{rowData?.[col.name] ? rowData?.[col.name] : ''}</p>
                    }}
                </Cell>
            </Column>
        )
    })

    const handleActivateDeactivateClick = async (contactData = null) => {
        const contactId = contactData?.id || null
        if (!contactId) {
            toast.show({
                title: 'Warning',
                description: 'No contact id found!'
            })
            return
        }

        if (contactData?.status) {
            try {
                setIsContactLinkedLoading({ isLoading: true, contactId })
                const result = await dispatch(checkContactLinkedWithMaster({ contactId }))
                setIsContactLinkedLoading({ isLoading: false, contactId: null })
                if (result?.isLinked) {
                    toast.show({
                        title: 'Danger',
                        description: 'Cannot deactivate a contact that is actively linked to a master supplier!'
                    })
                    return
                }
            } catch (err) {
                setIsContactLinkedLoading({ isLoading: false, contactId: null })
                toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message || 'Failed to check that contact linked with master or not!'
                })
                return
            }

            setContactId(contactId)
            setShowDeleteConfirmation(true)
        } else {
            setIsContactLinkedLoading({ isLoading: true, contactId })
            dispatch(updateContact({
                contactId,
                contactData: {
                    ...contactData,
                    status: true
                }
            })).then(() => {
                setIsContactLinkedLoading({ isLoading: false, contactId: null })
                onGetContactsData(null, true)
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message || 'Failed to activate contact!'
                })
                setIsContactLinkedLoading({ isLoading: false, contactId: null })
            })
        }
    }

    const onCloseDeleteConfirmation = () => {
        setContactId(null)
        setShowDeleteConfirmation(false)
    }

    const onDeleteContact = () => {
        if (contactId) {
            setIsLoading(true)
            dispatch(deleteContact({ contactId })).then(res => {
                toast.show({
                    title: 'Success',
                    description: 'Contact deleted successfully!',
                })
                setIsLoading(false)
                onCloseDeleteConfirmation()
                onGetContactsData(null, true)
            }).catch((err) => {
                toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message || 'Failed to delete contact!'
                })
                setIsLoading(false)
            })
        }
    }

    const handleEditClick = (contactId = null) => {
        setContactId(contactId)
        setShowEditModal(true)
    }

    const onCloseEditModal = () => {
        setContactId(null)
        setShowEditModal(false)
    }

    useEffect(() => {
        if (isRelaodContacts) {
            onGetContactsData()
            setIsRelaodContacts(false)
        }
    }, [isRelaodContacts])

    const paginatedData = contacts?.sort((a, b) => {
    }).slice(limit * (page - 1), limit * page)

    return (
        <div className="card contacts-data mt-5">
            <div className="card-header">
                <h3 className="mb-0 fw-bold text-blue">Contacts Information</h3>
            </div>
            <div className="card-content contacts-table px-0">
                <Table
                    virtualized
                    height={500}
                    affixHeader={true}
                    data={paginatedData}
                >
                    {headerElements}
                    <Column
                        width={250}
                        fixed="right"
                        key="action"
                    >
                        <HeaderCell>Action</HeaderCell>
                        <ActionCell
                            onActivateDeactivateClick={handleActivateDeactivateClick}
                            onEditClick={handleEditClick}
                            isContactLinkedLoading={isContactLinkedLoading}
                        />
                    </Column>
                </Table>
                <div className="child-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        maxButtons={5}
                        activePage={page}
                        showInfo
                        layout={['limit', '|', 'pager']}
                        displayLength={limit}
                        total={contacts?.length || 0}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        onChangePage={(event) => { setPage(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div>
            </div>
            {showDeleteConfirmation && (
                <Modal backdrop={'static'} className={`position-relative`} show={showDeleteConfirmation} onHide={onCloseDeleteConfirmation}>
                    <Modal.Header>
                        <Modal.Title className='fw-bold text-blue fs-2'>
                            Deactivate Contact
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={`d-flex flex-column align-items-center${isLoading ? ' position-relative loading' : ''}`}>
                        {isLoading && <LoaderComponent />}
                        <h3 className='mb-0 text-black fw-bold'>Are you sure you want to deactivate this contact?</h3>
                        <div className='mt-4'>
                            <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={onCloseDeleteConfirmation}>No</button>
                            <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100' onClick={onDeleteContact}>Yes</button>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
            {showEditModal && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showEditModal} handleClose={onCloseEditModal} dialogClassName='px-5 edit-new-contact-modal-dialog'
                    >
                        <CreateContact onClose={onCloseEditModal} contactId={contactId} isEdit={true} setIsRelaodContacts={setIsRelaodContacts} />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default Contacts